<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <div class="navbar-brand">Summary Report</div>
      <div class="d-flex flex-row align-items-center ms-auto" style="gap: 10px"  *ngIf="is_mario">
        <span>Filter</span>
        <input type="month" [value]="filterMonth" (change)="monthChange($event)"/>
        </div>
    </div>
  </nav>
  <hr/>

  <div class="py-3 px-4" *ngIf="is_loading">
    Loading...
  </div>
    
  <table class="table table-sm">
    <tbody class="mb-3" *ngFor="let summary of summaries">
        <tr>
            <th colspan="9" style="background: rgb(var(--color))">{{summary.month}}</th>
        </tr>
        <tr style="background: rgba(var(--color),0.5)">
            <th>Company</th>
            <th class="border-start border-end">Capital 本金</th>
            <th class="border-start border-end">Spend</th>
            <th class="border-start border-end">Profit</th>
            <th class="border-start border-end">Net Profit</th>
            <th class="border-start border-end">Last Month Cash</th>
            <th class="border-start border-end">Cash</th>
            <th class="border-start border-end">Manager Checked</th>
            <th></th>
        </tr>
        <tr *ngFor="let company of summary.companies">
            <td class="border-start border-end">{{company.company_name}}</td>
            <td class="border-start border-end text-end" *ngIf="company.capital >= 0">{{(company.capital ?? 0) | number: '1.2-2'}}</td>
            <td class="border-start border-end text-end text-success fw-bolder" *ngIf="company.capital < 0">Profit</td>
            <td class="text-danger border-start border-end text-end">{{company.expenses | number: '1.2-2'}}</td>
            <td class="border-start border-end text-end" [ngClass]="{'text-danger': company.profit < 0}">{{company.profit | number: '1.2-2'}}</td>
            <td class="border-start border-end text-end" [ngClass]="{'text-danger': company.net_profit < 0}">{{company.net_profit | number: '1.2-2'}}</td>
            <td class="border-start border-end text-end" [ngClass]="{'text-danger': company.cash_bf < 0}">
                <ng-container *ngIf="permission['summary-report-admin'] && !company.summary_checked; else cashBfView">
                    <input type="number" class="form-control form-control-sm text-end py-0 px-1 d-inline-block" style="max-width: 130px" [(ngModel)]="company.cash_bf" (ngModelChange)="updateCash(company)" />
                </ng-container>
                <ng-template #cashBfView>{{company.cash_bf | number: '1.2-2'}}</ng-template>
            </td>
            <th class="border-start border-end text-end" [ngClass]="{'text-danger': company.cash < 0}">{{company.cash | number: '1.2-2'}}</th>
            <td><input type="checkbox" [(ngModel)]="company.summary_checked" [value]="1" [disabled]="!permission['summary-report-admin']" /></td>
            <td><button *ngIf="permission['summary-report-admin']" class="btn btn-sm btn-success py-0 px-1 small" (click)="save(company)">SAVE</button></td>
        </tr>
        <tr style="background: rgba(var(--color),0.8)">
            <th></th>
            <th class="border-start border-end text-end">{{sum('capital', summary.companies) + sum('add_capital', summary.companies) - sum('withdraw_capital', summary.companies) | number: '1.2-2'}}</th>
            <th class="text-danger border-start border-end text-end">{{sum('expenses', summary.companies) | number: '1.2-2'}}</th>
            <th class="border-start border-end text-end" [ngClass]="{'text-danger': sum('profit', summary.companies) < 0}">{{sum('profit', summary.companies) | number: '1.2-2'}}</th>
            <th class="border-start border-end text-end" [ngClass]="{'text-danger': sum('net_profit', summary.companies) < 0}">{{sum('net_profit', summary.companies) | number: '1.2-2'}}</th>
            <th class="border-start border-end text-end" [ngClass]="{'text-danger':sum('cash_bf', summary.companies) < 0}">{{sum('cash_bf', summary.companies) | number: '1.2-2'}}</th>
            <th class="border-start border-end text-end" [ngClass]="{'text-danger':sum('cash', summary.companies) < 0}">{{sum('cash', summary.companies) | number: '1.2-2'}}</th>
            <th></th>
            <th></th>
        </tr>
        <tr>
            <th colspan="9" style="height: 30px; border-bottom: 0"></th>
        </tr>
    </tbody>
    
</table>
<!-- 
<ng-container *ngIf="permission.edit_summary_report == '1' && !is_loading">
<hr/>

<h3 class="fw-bolder" >Capital Adjustment</h3>

<table>
    <ng-container  *ngFor="let summary of summaries; let i = index">
    <tbody class="mb-3"  *ngIf="i == 0">
        <tr>
            <th colspan="10" style="background: rgb(var(--color))">{{summary.month}}</th>
        </tr>
        <tr style="background: rgba(var(--color),0.5)">
            <th>Company</th>
            <th>Capital 本金</th>
            <th>+ Capital 本金</th>
            <th>Withdraw 本金</th>
            <th></th>
        </tr>
        <tr *ngFor="let company of summary.companies">
            <td>{{company.company_name}}</td>
            <td>{{(company.capital_balance ?? 0) + (company.add_capital ?? 0) - (company.withdraw_capital)  | number: '1.2-2'}}</td>
            <td><input type="number" [(ngModel)]="company.add_capital" (input)="update(company)" [disabled]="!company.edit_summary_report || company.summary_checked" /></td>
            <td><input type="number" [(ngModel)]="company.withdraw_capital" (input)="update(company)" [disabled]="!company.edit_summary_report || company.summary_checked" /></td>
            <td><button  *ngIf="company.edit_summary_report == '1'" class="btn btn-sm btn-success py-0 px-1 small" (click)="save(company)">SAVE</button></td>
        </tr>
        <tr style="background: rgba(var(--color),0.8)">
            <td></td>
            <td>{{sum('start_balance', summary.companies) | number: '1.2-2'}}</td>
            <td>{{sum('add_capital', summary.companies) | number: '1.2-2'}}</td>
            <td>{{sum('withdraw_capital', summary.companies) | number: '1.2-2'}}</td>
            <td></td>
        </tr>
        <tr>
            <th colspan="10" style="height: 30px; border-bottom: 0"></th>
        </tr>
    </tbody>
</ng-container>
</table>
</ng-container> -->
<ng-container *ngIf="!is_loading"><app-company-share-report *ngFor="let summary of summaries" [report]="summary.share_split"></app-company-share-report></ng-container>
